import { EventType } from './event-type.interface';

export const ROOM_VIDEO: EventType = {
  name: 'Room Video Changed',
  description: 'When the video selection playing in a room has changed',
  route: 'rooms/3',
  category: 'Room Media',
  icon: 'watch',
  whitelist: [
    {
      proxy: 'roomdevice',
      events: [3]
    }
  ]
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-simple/event-types/room-video.type.ts